import React from 'react';
import { MainsReadyIcon, DessertReadyIcon } from './floorplan/OrderActionIcons';

/**
 * The grid-dashboard's table tile — checkbox select, occupied highlight/timer, checkout and
 * kitchen-print icons, and the simplified "Person/Tabs/Takeaway" variant. Shared between
 * DashboardPage (all tabs) and FloorPlanDashboardPage (special tabs only), so both screens
 * render these identically instead of duplicating the JSX.
 */
const SimpleTableTile = ({
  table,
  tabId,
  isSelected,
  isOccupied,
  info,
  isSpecialTab,
  onSelect,
  onInfoClick,
  onCheckout,
  onPrintKitchenDocket,
  getElapsed,
}) => {
  const customerName = info?.customerName;
  const orderName = info?.orderName;
  const tableName = table.name || `${table.tableNumber}`;

  const fullText = [orderName, tableName].filter(Boolean).join(" - ");
  const displayText = orderName || customerName || tableName || "";

  return (
    <div
      title={fullText}
      className={`tableCol${isSelected ? ' selected' : ''}${isOccupied ? ' reserved' : ''}${isSpecialTab ? ' specialTab' : ''}`}
    >
      <span
        className="infoTrigger"
        onClick={() => onInfoClick(table.id, table.name || `${table.tableNumber}`)}
      >
        <svg width="28" height="28" className="infoIcon" style={{ width: "28px" }}>
          <use href="/images/sprite.svg#iconInfo" />
        </svg>
      </span>

      <input
        type="checkbox"
        className="tableInput"
        name={`tableInput-${tabId}`}
        checked={isSelected}
        onChange={onSelect}
      />

      {isOccupied && !isSpecialTab && (
        <span style={{ position: "absolute", top: "14px", left: "50%", transform: "translateX(-50%)", whiteSpace: "nowrap" }}>
          {getElapsed(info.started)}
        </span>
      )}
      <svg width="24" height="24" className="checkSquareIcon">
        <use href="/images/sprite.svg#iconCheckSquare" />
      </svg>
      {isOccupied && !isSelected && (
        <span
          className="infoTrigger"
          onClick={onCheckout}
          style={{ left: "85%", transform: "translateX(-25%)" }}
        >
          <svg width="38" height="38" className="d-block" style={{ color: "#E94059", paddingRight: "8px" }}>
            <use xlinkHref="./images/sprite.svg#iconCheckout"></use>
          </svg>
        </span>
      )}
      <label>
        <span className="tableWithText">
          <img
            className="tableImg"
            src={table.img}
            alt={table.name || `${table.tableNumber}`}
          />
          {!isSpecialTab && (
            <ul className="tableText">
              <li className="tableNumber">
                <svg width="21" height="14" className="tableNumberIcon">
                  <use xlinkHref="./images/sprite.svg#iconTableNumber"></use>
                </svg>
                <span>#{table.tableNumber}</span>
              </li>
              <li className="personNumber">
                <svg width="11" height="10" className="personIcon">
                  <use href="/images/sprite.svg#iconPersons" />
                </svg>
                <span>{table.personNumber}</span>
              </li>
            </ul>
          )}
        </span>
      </label>

      {isOccupied && !isSpecialTab && (
        <span
          className="cTimeCol"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onPrintKitchenDocket('c');
          }}
          style={{ cursor: 'pointer', zIndex: 15 }}
        >
          <MainsReadyIcon width="40" height="40" style={{ color: 'black' }} />
        </span>
      )}

      {isSpecialTab && (
        <div
          className="cTimeCol"
          style={{ textAlign: "center", left: "50%", transform: "translateX(-50%)" }}
        >
          {displayText}
        </div>
      )}
      {isOccupied && !isSpecialTab && (
        <span
          className="tblIcons"
          style={{ cursor: 'pointer', zIndex: 15 }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onPrintKitchenDocket('d');
          }}
        >
          <DessertReadyIcon width="40" height="40" style={{ color: 'black' }} />
        </span>
      )}
    </div>
  );
};

export default SimpleTableTile;
